const PaymentStatus = {
  APPROVED_INVOICE: 1,
  APPROVED_PAYMENT: 2,
};

const PaymentCreationSource = {
  PAYMENT_ONLY: 1,
  INDENT_MANAGED: 2,
};

const ChargesBy = {
  SYSTEM: 1,
  TRANSPORTER: 2,
  SHIPPER: 3,
};

const NoteType = {
  CREDIT: 1,
  DEBIT: 2,
};

const Movement = {
  SECONDARY: 1,
  PRIMARY: 2,
  VENDOR: 3,
  RETURN: 4,
};

const AdditionalChargesMethod = {
  ADD: 1,
  SUBTRACT: 2,
};

const PaymentCreateHeader = {
  sno: 'sno',
  'Indent ID': 'order_no',
  'Transporter Code': 'transporter_ref_id',
  'Truck Type': 'truck_ref_id',
  Delivery: 'delivery_code',
  'Material Code': 'material_ref_id',
  Quantity: 'quantity',
  'Quantity Unit': 'quantity_unit',
  Weight: 'weight',
  'Weight Unit': 'weight_unit',
  Volume: 'volume',
  'Volume Unit': 'volume_unit',
  'Source Code': 'source_code',
  'Destination Code': 'destination_code',
  'Invoice Amount': 'invoice_amount',
  'Invoice Number': 'invoice_number',
  'Invoice Date': 'invoice_date',
  MRP: 'mrp',
  'Dispached Date': 'dispached_date',
  Movement: 'movement',
};
const MultiMonthPaymentConstants = {
  'INDENT_CREATED_DATE': 1,
  'INDENT_DELIVERED_DATE': 2,
};
const PaymentHeader = {
  'Indent Id': 'order_reference',
  'Truck Number': 'truck_reference',
  Source: 'source',
  Destination: 'destinations',
  Consignee: 'consignees',
  'LR Number': 'lr_numbers',
  'Quantity(Case/Box/Bag)': 'quantity',
  'Dispatched Date': 'dispatch_date',
  'Base Freight': 'contract_charge',
  'Bfr Charge': 'bdr_charge',
  'unloading Detention': 'unloading_detention_charge',
  'Miscellaneous Charges': 'extra_charges',
  'Fixed Charge': 'Fixed Charge',
  ODA: 'oda_charge',
  'Additional Point': 'additional_point_charges',
  LR: 'lr_charge',
  Unloading: 'unloading_charge',
  'Loading Detention': 'loading_detention_charge',
  Loading: 'loading_charge',
  'Transit Delay': 'transit_charge',
  'Truck Type': 'truck_type',
};

const IndentCleanType = {
  unloading_detention_charge: 1,
  loading_detention_charge: 2,
  transit_charge: 3,
  shortage_charge: 4,
  damage_charge: 5,
  leakage_charge: 6,
  carton_damage_charge: 7,
  additionalPoint: 8,
  slaDelay: 9,
  cartonDamage: 10,
  freight: 11,
  damage: 12,
  loading: 13,
  loadingDetention: 14,
  lr: 15,
  oda: 16,
  shortage: 17,
  transitDelay: 18,
  unloading: 19,
  unloadingDetention: 20,
  fixed_charge: 21,
};

const ChargeTypes = [
  { type: 'system', suffixLabel: '- SG' },
  { type: 'transporter', suffixLabel: '- TR' },
  { type: 'client', suffixLabel: '- Final' }];

const PaymentStatusTypes = {
  POSTED: {
    id: 1,
    label: 'posted',
  }, // Posted In ERP
  HOLD: {
    id: 2,
    label: 'hold',
  },
  PAID: {
    id: 3,
    label: 'paid',
  }, // PAID
};

const PaymentStrategies = {
  additionalPoint: {
    1: 'pointCharges',
  },
  cartonDamage: {
    1: 'cartonDamageUsingFixedValue',
    2: 'cartonDamageUsingFactorAndMrp',
    3: 'cartonDamageUsingInvoice',
    4: 'cartonDamageUsingAmount',
    5: 'cartonDamageUsingBaseFreight'
  },
  damage: {
    1: 'damageUsingFixedConstant',
    2: 'damageUsingFactorAndMrp',
    3: 'damageUsingInvoice',
    4: 'damageUsingAmount',
    5: 'damageUsingBaseFreight',
  },
  freight: {
    1: 'freightRateMaximum',
  },
  bdr: {
    1: 'fixedBdrCharge',
  },
  leakage: {},
  loading: {
    1: 'loadingWithSourceDepots',
  },
  loadingDetention: {
    1: 'calculateDetentionDelayWithLoadingDate',
    2: 'calculateDetentionDelayWithLoadingDateClientConfigBased',
  },
  loadingDetentionDays: {
    1: 'calculateDetentionDaysWithLoadingDateCalc',
    2: 'calculateDetentionDaysWithLoadingDateCalcClientConfigBased',
  },
  lr: {},
  miscellaneous: {},
  oda: {
    1: 'odaCharges',
  },
  fixedCharge: {
    1: 'fixedCharges',
    2: 'computeFixedChargeBasedOnDeliveryType'
  },
  penalty: {},
  shortage: {
    1: 'shortageUsingFixedConstant',
    2: 'shortageUsingFactorAndMrp',
    3: 'shortageUsingInvoice',
    4: 'shortageUsingAmount',
    5: 'shortageUsingBaseFreight',
  },
  slaDelay: {
    1: 'arrivalDelayWithFixedValue',
  },
  total: {
    1: 'totalAmountCalculation',
  },
  transitDelay: {
    1: 'calculateDetentionCharges',
    2: 'transitDelayByTransporterPerformance',
  },
  unloading: {
    1: 'unloadingBasedOnDepotCharges',
  },
  unloadingDetention: {
    1: 'calculateDeliveryDetentionWithTransitDaysCharges',
    2: 'calculateDeliveryDetentionWithTransitDaysChargesBasedOnClientConfig',
  },
  unloadingDetentionDays: {
    1: 'calculateDeliveryDetentionBasedOnExpectedDelivery',
    2: 'calculateDeliveryDetentionBasedOnExpectedDeliveryAndClientConfig',
  },
  mallCharge: {
    1: 'mallCharge',
  },
  appointmentCharge: {
    1: 'appointmentCharge',
  },
  ecc: {
    1: 'ecc',
  },
  customCharges: {
    1: 'compute',
    2: 'computeBasedOnDeliveryType',
  },
};

const InvoicePostingStrategies = {
  Default: 1,
  ByShippment: 2,
  SRF: 3,
  SIEMENS: 4,
};

const mrpUnit = {
  BOX: 1,
  PIECE_PER_BOX: 2,
};

const PaymentDiscountType = {
  TOTAL_BASE_VALUE: 1,
  BASE_FREIGHT: 2,
};

const PaymentBulkUpdateUpperLimit = 100;

const DefaultDetentionGroup = 'U';

// used in payment calculation based on strategy
const PaymentCharge = {
  LOADING: 'loading',
  UNLOADING: 'unloading',
  ODA: 'oda',
  FIXEDCHARGE: 'fixedCharge',
  FREIGHT: 'freight',
  SHORTAGE: 'shortage',
  DAMAGE: 'damage',
  CARTONDAMAGE: 'cartonDamage',
  ARRIVALDELAY: 'arrivalDelay',
  ADDITIONALPOINT: 'additionalPoint',
  LOADINGDETENTION: 'loadingDetention',
  UNLOADINGDETENTION: 'unloadingDetention',
  TRANSITDELAY: 'transitDelay',
  DEDUCTIBLES: 'deductibles',
  BDR: 'bdr',
  RTOCHARGES: 'rtoCharges',
  MALLCHARGE: 'mallCharge',
  APPOINTMENTCHARGE: 'appointmentCharge',
  ECC: 'ecc',
  CUSTOMCHARGE: 'customCharges',
  HILLYREGIONCHAREGE: 'hillyRegionCharge',
  RETURNFREIGHTCHARGE: 'returnFreightCharge',
  TRANSPORTERDEBIT: 'transporterDebit',
};

const getPaymentTypes = () => ({
  STANDARD_PAYMENT: 1,
  DEDICATED_TRUCK_WITHOUT_INDENT_PAYMENT: 2,
  DEDICATED_TRUCK_WITH_INDENT_PAYMENT: 3,
});

const getDigitalSignatureStatus = () => ({
  TRANSPORTER_UPLOADED_DIGITAL_SIGNATURE: 'TRANSPORTER_UPLOADED_DIGITAL_SIGNATURE',
  CHECKER_VERIFIED_DIGITAL_SIGNATURE: 'CHECKER_VERIFIED_DIGITAL_SIGNATURE',
  APPROVED_DIGITAL_SIGNATURE: 'APPROVED_DIGITAL_SIGNATURE',
});

const eInvoiceStatus = {
  INVOICE_VALIDATED: 1,
  INVOICE_MISMATCHED: 2,
  IRN_EXPIRED: 3,
};

const PaymentIndentAssociationTypes = {
  ROUNDTRIP_PARENT: 'roundtrip_parent',
  ROUNDTRIP_CHILD: 'roundtrip_child',
};

const Metrics = {
  Kg: 'kg',
  Cft: 'cft',
};

const getErrorMessages = () => ({
  ERROR_CAN_NOT_COMBINE_DIFFERENT_TYPES_OF_PAYMENTS: 'Cannot combine dedicated truck payment' +
  ' and standard payment / payments not available in the system',
  ERROR_CAN_NOT_COMBINE_DIFFERENT_VT_TYPES_OF_DEDICATED_PAYMENTS: 'Cannot combine dedicated' +
    ' truck payments of different vehicle type / depot / transporter / client',
});

// TODO: whenever new charges added same has to be added into these charges constants
// charges constants - starts
const getV2CreditChargesAppNameList = () => ([
  'unloadingDetention',
  'oda',
  'freight',
  'unloading',
  'loadingDetention',
  'loading',
  'fixedCharge',
  'extraCharge',
  'lrCharge',
  'additionalPoint',
  'extra_km_charge',
  'bdr',
  'rtoCharges',
  'mallCharge',
  'appointmentCharge',
  'ecc',
  'custom_charges',
  'hillyRegionCharge',
  'returnFreightCharge',
]);
const getV2DebitChargesAppNameList = () => ([
  'arrivalDelay',
  'transitDelay',
  'damage',
  'shortage',
  'cartonDamage',
  'leakage',
  'deductible',
  'transporterDebit',
]);
const getV2CreditChargesMap = () => ({
  UNLOADING_DETENTION_CHARGE: 'unloading_detention_charge',
  ODA_CHARGE: 'oda_charge',
  CONTRACT_CHARGE: 'contract_charge',
  UNLOADING_CHARGE: 'unloading_charge',
  LOADING_CHARGE: 'loading_charge',
  LOADING_DETENTION_CHARGE: 'loading_detention_charge',
  FIXED_CHARGE: 'fixed_charge',
  EXTRA_CHARGES: 'extra_charges',
  LR_CHARGE: 'lr_charge',
  ADDITIONAL_POINT_CHARGES: 'additional_point_charges',
  EXTRA_KM_CHARGE: 'extra_km_charge',
  MALL_CHARGE: 'mall_charge',
  APPOINTMENT_CHARGE: 'appointment_charge',
  ECC: 'ecc'
});
const getV2DebitChargesMap = () => ({
  ARRIVAL_CHARGE: 'arrival_charge',
  TRANSIT_CHARGE: 'transit_charge',
  SHORTAGE_CHARGE: 'shortage_charge',
  DAMAGE_CHARGE: 'damage_charge',
  CARTON_DAMAGE_CHARGE: 'carton_damage_charge',
  LEAKAGE_CHARGE: 'leakage_charge',
  DEDUCTIBLES: 'deductibles',
  TRANSPORTER_DEBIT: 'transorter_debit'
});

const getAdjustableChargeNamesMap = {
  base_freight_value: 'freightCharge',
  oda_freight: 'odaCharge',
  fixed_charge: 'fixedCharge',
  additional_point_charge: 'additionalPointCharge',
  miscellaneous_charge: 'extraCharge',
  loading_charge: 'loadingCharge',
  unloading_charge: 'unloadingCharge',
  lr_charge: 'lrCharge',
  unloading_detention: 'unloadingDetentionCharge',
  loading_detention: 'loadingDetentionCharge',
  contribution: 'totalAmount',
};

const getV2ChargesMap = () => {
  const creditMap = getV2CreditChargesMap();
  const debitMap = getV2DebitChargesMap();
  const calculatedCharges = {
    TOTAL_AMOUNT: 'total_amount',
    WALLET_PENALTY_CHARGE: 'wallet_penalty_charge',
    TRANSPORTER_DEBIT_ADJUST: 'transporter_debit_adjust',
  };
  return Object.assign({}, creditMap, debitMap, calculatedCharges);
};

const getV2DBtoAppChargesNameMap = () => {
  const { ADDITIONAL_POINT_CHARGES,
    ARRIVAL_CHARGE,
    CARTON_DAMAGE_CHARGE,
    CONTRACT_CHARGE,
    DAMAGE_CHARGE,
    EXTRA_CHARGES,
    LEAKAGE_CHARGE,
    LOADING_CHARGE,
    LOADING_DETENTION_CHARGE,
    LR_CHARGE,
    ODA_CHARGE,
    FIXED_CHARGE,
    SHORTAGE_CHARGE,
    EXTRA_KM_CHARGE,
    TRANSIT_CHARGE,
    UNLOADING_CHARGE,
    UNLOADING_DETENTION_CHARGE,
    TOTAL_AMOUNT,
    MALL_CHARGE,
    APPOINTMENT_CHARGE,
    ECC,
    WALLET_PENALTY_CHARGE, // calculated one no need configure this
    TRANSPORTER_DEBIT_ADJUST, // calculated one no need configure this
  } = getV2ChargesMap();
  const result = {};
  result[UNLOADING_DETENTION_CHARGE] = 'unloadingDetention';
  result[ODA_CHARGE] = 'oda';
  result[CONTRACT_CHARGE] = 'freight';
  result[UNLOADING_CHARGE] = 'unloading';
  result[LOADING_DETENTION_CHARGE] = 'loadingDetention';
  result[LOADING_CHARGE] = 'loading';
  result[FIXED_CHARGE] = 'fixedCharge';
  result[EXTRA_CHARGES] = 'extraCharge';
  result[LR_CHARGE] = 'lrCharge';
  result[ADDITIONAL_POINT_CHARGES] = 'additionalPoint';
  result[EXTRA_KM_CHARGE] = 'extra_km_charge';
  result[ARRIVAL_CHARGE] = 'arrivalDelay';
  result[TRANSIT_CHARGE] = 'transitDelay';
  result[DAMAGE_CHARGE] = 'damage';
  result[SHORTAGE_CHARGE] = 'shortage';
  result[CARTON_DAMAGE_CHARGE] = 'cartonDamage';
  result[LEAKAGE_CHARGE] = 'leakage';
  result[TOTAL_AMOUNT] = 'totalAmount';
  result[MALL_CHARGE] = 'mall_charge';
  result[APPOINTMENT_CHARGE] = 'appointment_charge';
  result[ECC] = 'ecc';
  return result;
};

const erpPayloadStatus = {
  DISPATCHED: 'DISPATCHED',
  DELIVERED: 'DELIVERED',
  DELIVERY_PENDING: 'DELIVERY_PENDING',
  PARTIALLY_INVOICED: 'PARTIALLY INVOICED',
  INVOICED: 'INVOICED',
  CHECKED: 'CHECKED',
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
};

const erpIndentStatus = {
  DISPATCHED: 'dispatched',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  INVOICED: 'invoiced',
  INVOICE_APPROVED: 'invoice_approved',
};

const paymentCountType = {
  FREIGHT_BILL: 'freight_bill',
};

const TWO_DAYS_IN_SECONDS = 172800;

// charges constants - ends
module.exports = {
  IndentCleanType,
  PaymentStatus,
  PaymentCreationSource,
  ChargesBy,
  NoteType,
  PaymentHeader,
  MultiMonthPaymentConstants,
  AdditionalChargesMethod,
  ChargeTypes,
  PaymentBulkUpdateUpperLimit,
  PaymentStatusTypes,
  PaymentCreateHeader,
  PaymentStrategies,
  Movement,
  InvoicePostingStrategies,
  mrpUnit,
  DefaultDetentionGroup,
  PaymentCharge,
  getPaymentTypes,
  Metrics,
  getErrorMessages,
  getV2ChargesMap,
  getV2DebitChargesMap,
  getV2CreditChargesMap,
  getV2CreditChargesAppNameList,
  getV2DebitChargesAppNameList,
  getV2DBtoAppChargesNameMap,
  erpPayloadStatus,
  erpIndentStatus,
  paymentCountType,
  PaymentIndentAssociationTypes,
  TWO_DAYS_IN_SECONDS,
  getAdjustableChargeNamesMap,
  getDigitalSignatureStatus,
  eInvoiceStatus,
  PaymentDiscountType,
};
